module.exports = __webpack_public_path__ + "static/media/Marcsc-01.f08f9b9f.svg";